import React, { useEffect, useState } from "react";
import axios from "axios";
import './ContactPerson.css' 

const ContactPerson = () => {
  const [contacts, setContacts] = useState([]);

  // Fetch data from the backend
  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get("https://pharmabackend-1.onrender.com/api/contacts");
        setContacts(response.data);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      }
    };

    fetchContacts();
  }, []);

  return (
    <div className="contact-person-container">
      <h2>Contact Persons</h2>
      <table className="contact-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Company</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Message</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((contact) => (
            <tr key={contact._id}>
              <td>{contact.name}</td>
              <td>{contact.company}</td>
              <td>{contact.email}</td>
              <td>{contact.phone}</td>
              <td>{contact.message}</td>
              <td>{new Date(contact.createdAt).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContactPerson;